<ng-container>
	<app-uuid-invite-card *ngIf="isFromUUID && isJobLink"></app-uuid-invite-card>
	<!-- <app-job-share-list-card *ngIf="isJobList" [encodeUrl]="encodeUrl"></app-job-share-list-card> -->
</ng-container>